const Footer = () => {
    return (
        <footer class="footer d-flex flex-column flex-md-row align-items-center justify-content-between px-4 py-3 border-top small ltr">
            <p class="text-muted mb-1 mb-md-0 tx-13">© {new Date().getFullYear()} <a href="/" target="/">IMS</a> حل تجاري لإدارة المخزون بكفاءة</p>
        </footer>
    );
}


export default Footer;